import "./App.css";
import { Counter } from "./features/counter/Counter";
import { Sent } from "./features/sent/Sent";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Counter />
        <Sent />
      </header>
    </div>
  );
}

export default App;
